import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useSelector } from 'react-redux';
import useDialog from './usePasswordDialog';
import { Trans } from "@lingui/react/macro";

const PasswordDialog = () => {
  const { open, onConfirm } = useSelector((state: {'passwordDialog': any}) => state.passwordDialog);
  const { closeDialog } = useDialog();

  return (
    <div>
      <Dialog open={open} onClose={() => closeDialog()}>
        <DialogTitle><Trans>Confirm Password</Trans></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans>Please confirm delete of the entity.</Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}><Trans>Cancel</Trans></Button>
          <Button onClick={() => onConfirm('password')}><Trans>OK</Trans></Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PasswordDialog;
